import React from "react";
import { whatsappNumber, whatsappMessage } from "../../data/siteData";
import "./FinalCTA.css";

function FinalCTA() {
  const link = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    whatsappMessage
  )}`;

  return (
    <section className="final-cta">
      <div className="container final-cta__box">
        <h2>Quer colocar essas sobremesas no seu cardápio?</h2>

        <p>
          Fale agora no WhatsApp e receba todas as informações para começar.
        </p>

        <a href={link} target="_blank" rel="noreferrer" className="btn-whatsapp">
          Falar no WhatsApp agora
        </a>
      </div>
    </section>
  );
}

export default FinalCTA;